import client from "utils/api";
import store from 'utils/store'
import analytics from 'utils/analytics'
import Cookies from 'js-cookie'
import {push} from 'react-router-redux'
function _login({data}){
  Cookies.set('stories_session', data.user.token, {expires: 15})
  store.dispatch({type:"LOGIN", payload: data})
  if(Cookies.get("stories_url")){
    store.dispatch(push(Cookies.get("stories_url")))
    Cookies.remove('stories_url')
  }
  return data
}

function authUser(object){
  return client().post(`/users/facebook`,object)
    .then(_login)
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}
function login(object){
  return client().post(`/users/login`,object)
    .then(_login)
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"Wrong username or password."})
    });
}
function register(object){
  object.firstName=object.name.split(" ")[0]
  object.lastName=object.name.split(" ")[1]
  return client().post(`/users`, object)
    .then((response) => {
      analytics.track("register")
      return _login(response)
    })
    .catch(e => {
      if(e.response.data.err==="Email already used"){
        store.dispatch({type:"ADD_TOAST", message:"This email is already used on Stori. Please login instead or use another email."})
        return
      }
      store.dispatch({type:"ADD_TOAST", message:"There was some errors on Stori. Please, try again later."})
    });
}


export default {
  authUser,
  login,
  register
}



// WEBPACK FOOTER //
// ./src/components/auth/api.js